import { ServiceData } from '@/types';

import audios from './MEDITATION_AUDIOS_LT.json';
import guides from './MEDITATION_GUIDES_LT.json';

export const MEDITATION_DATA_LT: ServiceData = {
  audios,
  guides,
};
